import Vue from "vue";
import VueRouter from "vue-router";
import AuthService from "../services/auth.service";

import Login from "../views/Login.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import ResetPassword from "@/views/ResetPassword.vue";

import Layout from "../views/Layout.vue";
import Dashboard from "../views/Dashboard.vue";
import Course from "../views/Course.vue";
import Glossary from "../views/Glossary.vue";
import Tool from "../views/Tool.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/"
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: ForgotPassword
  },
  {
    path: "/reset-password/",
    name: "ResetPassword",
    component: ResetPassword
  },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    redirect: "/dashboard",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "/tool/:id",
        name: "Course Tool",
        component: Tool
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "/course/:module/:step",
        name: "Course",
        component: Course
      },
      {
        path: "/glossary",
        name: "Glossary",
        component: Glossary
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = AuthService.isAuthenticated();
  
  if (requiresAuth && !currentUser) {
    next("/login");
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
